module.exports = __webpack_public_path__ + "img/slideVerify_08.5dcc096e.png";